import { gettext } from '@eventbrite/i18n';
import React, { useState } from 'react';

import { ScrollableDrawer } from '../../../ScrollableDrawer/ScrollableDrawer';
import { ExpandingButtonLink } from '../../../_shared/ButtonLink';
import { AgendaDrawerContent } from './AgendaDrawerContent';
import { Tab } from './types';

import { DrawerContent } from '../../../ScrollableDrawer/DrawerContent';
import styles from './AgendaReadMoreButton.module.scss';

export const AgendaDrawer = ({
    open,
    onClose,
    tabs,
}: {
    open: boolean;
    onClose: () => void;
    tabs: Tab[];
}) => {
    if (!open) {
        return null;
    }

    return (
        <ScrollableDrawer
            onClickOutside={onClose}
            isScrollUpAllowed={false}
            showCloseButton={true}
        >
            <DrawerContent>
                <AgendaDrawerContent tabs={tabs} />
            </DrawerContent>
        </ScrollableDrawer>
    );
};

export const AgendaReadMoreButton = ({
    tabs,
    onReadMoreClick,
}: {
    tabs: Tab[];
    onReadMoreClick: () => void;
}) => {
    const [open, setOpen] = useState(false);
    const [isExpanded, setExpanded] = useState(false);

    const handleReadMoreClick = () => {
        onReadMoreClick();
        setExpanded(!isExpanded);
    };

    const hideAgendaText = gettext('Hide agenda');
    const showAgendaText = gettext('Show all agenda');

    return (
        <>
            <ExpandingButtonLink
                className={styles['agenda__readMoreButton--desktop']}
                onClick={handleReadMoreClick}
                text={isExpanded ? hideAgendaText : showAgendaText}
            />
            <ExpandingButtonLink
                className={styles['agenda__readMoreButton--mobile']}
                onClick={() => setOpen(true)}
                text={showAgendaText}
            />
            <AgendaDrawer
                open={open}
                onClose={() => setOpen(false)}
                tabs={tabs}
            />
        </>
    );
};
